<template>
  <div v-if="pressLinks && pressLinks.length">
    <AthleteSectionSubheading>Press links</AthleteSectionSubheading>
    <div 
      class="mb-8 linkGrid"
    >
      <AthleteLinkCard
        class="w-full"
        v-for="(link) in sortedLinks"
        :key="link.id"
        :document="link"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AthleteSectionSubheading from "./AthleteSectionSubheading";
import AthleteLinkCard from "./AthleteLinkCard";

export default {
  components: {
    AthleteSectionSubheading,
    AthleteLinkCard
  },
  computed: {
    ...mapState({
      pressLinks: state => state.athleteProfile.user.pressLinks
    }),
    sortedLinks() {
      return this.pressLinks.sort((a,b) => a.order - b.order);
    }
  }
};
</script>

<style scoped>
.m-0 * {
  margin: 0 !important;
}
  .linkGrid {
    display: grid; 
    grid-template-columns: repeat(auto-fill, minmax(344px, 1fr)); 
    grid-gap: 1rem;
    @media screen and (max-width: 639px) {
      grid-template-columns: 100%; 
    }
  }
</style>